<ng-container *ngIf="initialized">
  <main class="container">
    <app-tabs></app-tabs>
    <router-outlet></router-outlet>
    <app-excluded-countries></app-excluded-countries>
    <app-version [show]="true"></app-version>
    <app-user-manual></app-user-manual>
  </main>
</ng-container>
